import { Route, Routes, Navigate } from "react-router-dom";
import { useEffect } from "react";
import Home from "./pages/Home/Home";
import NotFound from "./pages/404/NotFound";
import Navbar from "./components/Navbar/Navbar";
import ReactGA from "react-ga4";

const TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID as string;


function App() {
  useEffect(() => {
    ReactGA.initialize(TRACKING_ID);
  }, []);

  return (
    <>
      <Navbar />
      <Routes>
        {/* Define the Home route */}
        <Route path="/" element={<Home />} />

        {/* Catch-all route that redirects to /404 */}
        <Route path="/*" element={<Navigate to="/404" replace />} />

        {/* Define the 404 page route */}
        <Route path="/404" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
